import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

const CreateNewNocModal = ({ open, onClose, onConfirm, deleteFormLoading }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ color: "primary.main", fontSize: "20px" }}>
        Start Over and Create New NOC
      </DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to start over and upload a new Notice of
          Commencement?
        </Typography>
        <Typography color="error" fontWeight="bold" sx={{ mt: 1 }}>
          The current document will be permanently removed and cannot be
          recovered.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
        <Button
          disabled={deleteFormLoading}
          onClick={onClose}
          variant="outlined"
          color="secondary"
        >
          Cancel
        </Button>
        <LoadingButton
          loading={deleteFormLoading}
          onClick={onConfirm}
          variant="contained"
          color="error"
        >
          Yes, Start Over
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreateNewNocModal;
